import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";
import {getAuth} from "firebase/auth";


 
const firebaseConfig = {
  apiKey: "AIzaSyCEhGyNtctQGE59mh683H3e-fudscc3pM0",
  authDomain: "shreemangalmurtigases-8f056.firebaseapp.com",
  projectId: "shreemangalmurtigases-8f056",
  storageBucket: "shreemangalmurtigases-8f056.firebasestorage.app",
  messagingSenderId: "376088476635",
  appId: "1:376088476635:web:5f9d1dd66dca914c2105fe",
  measurementId: "G-M9LD8SS1TF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
export {db, storage, auth};


export default db;